import { defineMessages } from 'react-intl';

import { INTL_PREFIX } from './const';

export const aboutMessages = defineMessages({
  chronographs: {
    defaultMessage: 'chronographs',
    id: `${INTL_PREFIX.ABOUT}.chronographs`,
  },
  threeHands: {
    defaultMessage: 'three-hands',
    id: `${INTL_PREFIX.ABOUT}.threeHands`,
  },
  superquartz: {
    defaultMessage: 'superquartz',
    id: `${INTL_PREFIX.ABOUT}.superquartz`,
  },
  nonManufacture: {
    defaultMessage: 'non-manufacture',
    id: `${INTL_PREFIX.ABOUT}.nonManufacture`,
  },
  descriptionChronographs: {
    defaultMessage:
      'Breitling has been specializing in chronographs since Léon Breitling first laid down roots in the watchmaking industry in 1884. All of our Breitling Caliber 01-based chronograph movements are equipped with a column-wheel system, the hallmark of the finest mechanical chronograph movements, and are further distinguished by a vertical clutch that delivers precise and smooth chronograph operation. In addition to a power reserve of approximately 70 hours, the movement allows for calendar changes at any time without risk of damage. We have also partnered with top movement manufacturers to create precision chronographs that offer additional complications.',
    id: `${INTL_PREFIX.ABOUT}.description.chronographs`,
  },
  descriptionThreeHands: {
    defaultMessage:
      'Breitling’s manufacture time-only movements provide an exceptional power reserve.',
    id: `${INTL_PREFIX.ABOUT}.description.threeHands`,
  },
  descriptionSuperquartz: {
    defaultMessage:
      'Breitling’s sophisticated manufacture SuperQuartz™ thermo-compensated electronic chronograph calibers are 10 times more accurate than ordinary quartz and comply perfectly with the ultra-stringent demands of COSC testing.',
    id: `${INTL_PREFIX.ABOUT}.description.superquartz`,
  },
  descriptionNonManufacture: {
    defaultMessage:
      'Non-manufacture movements are engineered and sometimes produced by third-party suppliers like ETA, Sellita or Dubois-Depraz. They don’t belong exclusively to Breitling, but they must comply with our rigorous standards, including COSC certification. These movements are often used in high-volume, entry-level watches, or watches requiring specialized complications. Collaborating with trusted partners helps us meet demand while maintaining our commitment to quality, just like with our manufacture movements.',
    id: `${INTL_PREFIX.ABOUT}.description.nonManufacture`,
  },
  breitlingCaliber01Title: {
    defaultMessage: 'Breitling Caliber 01',
    id: 'caliber.breitlingCaliber01.title',
  },
  breitlingCaliber01Description: {
    defaultMessage:
      'Automatic chronograph caliber enabling you to measure elapsed times with the utmost precision.',
    id: 'caliber.breitlingCaliber01.description',
  },
  breitlingCaliber01Power: {
    defaultMessage: 'Approx. 70-hour power reserve',
    id: 'caliber.breitlingCaliber01.power',
  },
  breitlingCaliber01Diamonds: {
    defaultMessage: '28,800 VPH, 47 jewels',
    id: 'caliber.breitlingCaliber01.diamonds',
  },
  breitlingCaliber01Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.breitlingCaliber01.cosc',
  },

  caliberB02Title: {
    defaultMessage: 'CALIBER B02',
    id: 'caliber.caliberB02.title',
  },
  caliberB02Description: {
    defaultMessage:
      'Manual-wound chronograph movement enabling you to measure elapsed times with the utmost precision while displaying time in a 24h format. This special caliber was dedicated to the Navitimer Cosmonaute, the “First Swiss wristwatch in Space.“',
    id: 'caliber.caliberB02.description',
  },
  caliberB02Power: {
    defaultMessage: 'Approx. 70-hour power reserve',
    id: 'caliber.caliberB02.power',
  },
  caliberB02Diamonds: {
    defaultMessage: '28,800 VPH, 34 jewels',
    id: 'caliber.caliberB02.diamonds',
  },
  caliberB02Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB02.cosc',
  },

  caliberB03Title: {
    defaultMessage: 'CALIBER B03',
    id: 'caliber.caliberB03.title',
  },
  caliberB03Description: {
    defaultMessage:
      'Automatic rattrapante (or split-second) chronograph caliber enabling you to measure two elapsed times simultaneously, widely regarded as the most difficult chronograph complications to achieve.',
    id: 'caliber.caliberB03.description',
  },
  caliberB03Power: {
    defaultMessage: 'Approx. 70-hour power reserve',
    id: 'caliber.caliberB03.power',
  },
  caliberB03Diamonds: {
    defaultMessage: '28,800 VPH, 46 jewels',
    id: 'caliber.caliberB03.diamonds',
  },
  caliberB03Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB03.cosc',
  },

  caliberB04Title: {
    defaultMessage: 'CALIBER B04',
    id: 'caliber.caliberB04.title',
  },
  caliberB04Description: {
    defaultMessage:
      'Automatic chronograph GMT caliber enabling you to measure elapsed times with the utmost precision while displaying a second time zone.',
    id: 'caliber.caliberB04.description',
  },
  caliberB04Power: {
    defaultMessage: 'Approx. 70-hour power reserve',
    id: 'caliber.caliberB04.power',
  },
  caliberB04Diamonds: {
    defaultMessage: '28,800 VPH, 47 jewels',
    id: 'caliber.caliberB04.diamonds',
  },
  caliberB04Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB04.cosc',
  },

  caliberB05Title: {
    defaultMessage: 'CALIBER B05',
    id: 'caliber.caliberB05.title',
  },
  caliberB05Description: {
    defaultMessage:
      'Automatic chronograph caliber enabling you to measure elapsed times with the utmost precision, as well as tracking the time in any major city in the world.',
    id: 'caliber.caliberB05.description',
  },
  caliberB05Power: {
    defaultMessage: 'Approx. 70-hour power reserve',
    id: 'caliber.caliberB05.power',
  },
  caliberB05Diamonds: {
    defaultMessage: '28,800 VPH, 56 jewels',
    id: 'caliber.caliberB05.diamonds',
  },
  caliberB05Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB05.cosc',
  },

  caliberB09Title: {
    defaultMessage: 'CALIBER B09',
    id: 'caliber.caliberB09.title',
  },
  caliberB09Description: {
    defaultMessage:
      'Manual-wind chronograph caliber enabling you to measure elapsed times with the utmost precision. This manual-wind caliber is mainly used for historic re-editions and heritage-inspired pieces.',
    id: 'caliber.caliberB09.description',
  },
  caliberB09Power: {
    defaultMessage: 'Approx. 70-hour power reserve',
    id: 'caliber.caliberB09.power',
  },
  caliberB09Diamonds: {
    defaultMessage: '28,800 VPH, 28 jewels',
    id: 'caliber.caliberB09.diamonds',
  },
  caliberB09Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB09.cosc',
  },

  caliberB12Title: {
    defaultMessage: 'CALIBER B12',
    id: 'caliber.caliberB12.title',
  },
  caliberB12Description: {
    defaultMessage:
      'Automatic chronograph caliber enabling you to measure elapsed times with the utmost precision while displaying time in a 24h format.',
    id: 'caliber.caliberB12.description',
  },
  caliberB12Power: {
    defaultMessage: 'Approx. 70-hour power reserve',
    id: 'caliber.caliberB12.power',
  },
  caliberB12Diamonds: {
    defaultMessage: '28,800 VPH, 47 jewels',
    id: 'caliber.caliberB12.diamonds',
  },
  caliberB12Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB12.cosc',
  },

  caliberB15Title: {
    defaultMessage: 'CALIBER B15',
    id: 'caliber.caliberB15.title',
  },
  caliberB15Description: {
    defaultMessage:
      'Manual-wind rattrapante (or split-second) chronograph caliber enabling you to measure two elapsed times simultaneously, widely regarded as the most difficult chronograph complications to achieve.',
    id: 'caliber.caliberB15.description',
  },
  caliberB15Power: {
    defaultMessage: 'Approx. 70-hour power reserve',
    id: 'caliber.caliberB15.power',
  },
  caliberB15Diamonds: {
    defaultMessage: '28,800 VPH, 27 jewels',
    id: 'caliber.caliberB15.diamonds',
  },
  caliberB15Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB15.cosc',
  },

  caliberB19Title: {
    defaultMessage: 'CALIBER B19',
    id: 'caliber.caliberB19.title',
  },
  caliberB19Description: {
    defaultMessage:
      'Automatic chronograph enabling you to measure elapsed times with the utmost precision and display a perpetual calendar (day, date, month, moon phase & leap year). This 140th anniversary execution a solid gold oscillating weight engraved with the original Montbrillant street factory.',
    id: 'caliber.caliberB19.description',
  },
  caliberB19Power: {
    defaultMessage: 'Approx. 96-hour power reserve',
    id: 'caliber.caliberB19.power',
  },
  caliberB19Diamonds: {
    defaultMessage: '28,800 VPH, 39 jewels',
    id: 'caliber.caliberB19.diamonds',
  },
  caliberB19Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB19.cosc',
  },

  caliberB21Title: {
    defaultMessage: 'CALIBER B21',
    id: 'caliber.caliberB21.title',
  },
  caliberB21Description: {
    defaultMessage:
      'Automatic movement displaying the escapement in a tourbillon cage. Breitling worked closely with the movement maker La Joux-Perret to develop this caliber that takes the uncommon step of combining a tourbillon with a chronograph.',
    id: 'caliber.caliberB21.description',
  },
  caliberB21Power: {
    defaultMessage: 'Approx. 55-hour power reserve',
    id: 'caliber.caliberB21.power',
  },
  caliberB21Diamonds: {
    defaultMessage: '28,800 VPH, 30 jewels',
    id: 'caliber.caliberB21.diamonds',
  },
  caliberB21Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB21.cosc',
  },

  caliberB25Title: {
    defaultMessage: 'CALIBER B25',
    id: 'caliber.caliberB25.title',
  },
  caliberB25Description: {
    defaultMessage:
      'Automatic chronograph movement with display of day, date, month and moon phase. Breitling worked closely with the movement maker La Joux-Perret to develop this caliber that adds a perpetual calendar to a chronograph.',
    id: 'caliber.caliberB25.description',
  },
  caliberB25Power: {
    defaultMessage: 'Approx. 42-hour power reserve',
    id: 'caliber.caliberB25.power',
  },
  caliberB25Diamonds: {
    defaultMessage: '28,800 VPH, 37 jewels',
    id: 'caliber.caliberB25.diamonds',
  },
  caliberB25Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB25.cosc',
  },
  caliberB20Title: {
    defaultMessage: 'CALIBER B20',
    id: 'caliber.caliberB20.title',
  },
  caliberB20Description: {
    defaultMessage:
      'Automatic time-only movement based on Tudor’s Caliber MT5612. Allowing you to display time with the utmost accuracy while providing excellent resistance to shock and vibrations.',
    id: 'caliber.caliberB20.description',
  },
  caliberB20Power: {
    defaultMessage: 'Approx. 70-hour power reserve',
    id: 'caliber.caliberB20.power',
  },
  caliberB20Diamonds: {
    defaultMessage: '28,800 VPH, 26 jewels',
    id: 'caliber.caliberB20.diamonds',
  },
  caliberB20Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB20.cosc',
  },

  caliberB35Title: {
    defaultMessage: 'CALIBER B35',
    id: 'caliber.caliberB35.title',
  },
  caliberB35Description: {
    defaultMessage:
      'Automatic time-only movement allowing you to track the time in any major city in the world.',
    id: 'caliber.caliberB35.description',
  },
  caliberB35Power: {
    defaultMessage: 'Approx. 70-hour power reserve',
    id: 'caliber.caliberB35.power',
  },
  caliberB35Diamonds: {
    defaultMessage: '28,800 VPH, 41 jewels',
    id: 'caliber.caliberB35.diamonds',
  },
  caliberB35Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB35.cosc',
  },

  caliberB50Title: {
    defaultMessage: 'CALIBER B50',
    id: 'caliber.caliberB50.title',
  },
  caliberB50Description: {
    defaultMessage:
      'Multifunction SuperQuartz™ chronograph caliber, co-engineered with Soprod, offers split-time and flyback functions along with a second time zone, perpetual calendar, two alarms, a lap function and a countdown timer with alarm.',
    id: 'caliber.caliberB50.description',
  },
  caliberB50Power: {
    defaultMessage: 'Approx. 10-year battery life',
    id: 'caliber.caliberB50.power',
  },
  caliberB50Diamonds: {
    defaultMessage: '',
    id: 'caliber.caliberB50.diamonds',
  },
  caliberB50Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB50.cosc',
  },

  caliberB55Title: {
    defaultMessage: 'CALIBER B55',
    id: 'caliber.caliberB55.title',
  },
  caliberB55Description: {
    defaultMessage:
      'Connected multifunction SuperQuartz™ chronograph, co-engineered with Soprod, offers split-time and flyback functions along with a second time zone, perpetual calendar, two alarms, a lap function and a countdown timer with alarm. Connected to an application, you can set and access your data from a smartphone.',
    id: 'caliber.caliberB55.description',
  },
  caliberB55Power: {
    defaultMessage: 'Approx. 10-year battery life',
    id: 'caliber.caliberB55.power',
  },
  caliberB55Diamonds: {
    defaultMessage: '',
    id: 'caliber.caliberB55.diamonds',
  },
  caliberB55Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB55.cosc',
  },

  caliberB70Title: {
    defaultMessage: 'Caliber B70',
    id: 'caliber.caliberB70.title',
  },
  caliberB70Description: {
    defaultMessage:
      'Multifunctional SuperQuartz™ chronograph with split-time and flyback functions. It features a second timezone, a perpetual calendar, two alarms, a lap function, and a countdown timer with alarm. Developed with MMT.',
    id: 'caliber.caliberB70.description',
  },
  caliberB70Power: {
    defaultMessage: 'Approx. 2-3-year battery life',
    id: 'caliber.caliberB70.power',
  },
  caliberB70Diamonds: {
    defaultMessage: '',
    id: 'caliber.caliberB70.diamonds',
  },
  caliberB70Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB70.cosc',
  },

  caliber10Title: {
    defaultMessage: 'CALIBER 10',
    id: 'caliber.caliber10.title',
  },
  caliber10Description: {
    defaultMessage:
      'Automatic time-only movement supplied by either ETA or Sellita.',
    id: 'caliber.caliber10.description',
  },
  caliber10Power: {
    defaultMessage: 'Approx. 42-hour power reserve',
    id: 'caliber.caliber10.power',
  },
  caliber10Diamonds: {
    defaultMessage: '28,800 VPH, 25 jewels',
    id: 'caliber.caliber10.diamonds',
  },
  caliber10Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliber10.cosc',
  },

  caliber13Title: {
    defaultMessage: 'CALIBER 13',
    id: 'caliber.caliber13.title',
  },
  caliber13Description: {
    defaultMessage:
      'Automatic chronograph, supplied by either ETA or Sellita, enabling you to measure elapsed times on a 6-9-12 counter display.',
    id: 'caliber.caliber13.description',
  },
  caliber13Power: {
    defaultMessage: 'Approx. 48-hour power reserve',
    id: 'caliber.caliber13.power',
  },
  caliber13Diamonds: {
    defaultMessage: '28,800 VPH, 25 jewels',
    id: 'caliber.caliber13.diamonds',
  },
  caliber13Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliber13.cosc',
  },

  caliber17Title: {
    defaultMessage: 'CALIBER 17',
    id: 'caliber.caliber17.title',
  },
  caliber17Description: {
    defaultMessage:
      'Automatic time-only movement supplied by either ETA or Sellita.',
    id: 'caliber.caliber17.description',
  },
  caliber17Power: {
    defaultMessage: 'Approx. 38-hour power reserve',
    id: 'caliber.caliber17.power',
  },
  caliber17Diamonds: {
    defaultMessage: '28,800 VPH, 26 jewels',
    id: 'caliber.caliber17.diamonds',
  },
  caliber17Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliber17.cosc',
  },

  caliber19Title: {
    defaultMessage: 'CALIBER 19',
    id: 'caliber.caliber19.title',
  },
  caliber19Description: {
    defaultMessage:
      'Automatic chronograph, supplied by Dubois-Depraz, enabling you to measure elapsed times and display a four-year full-calendar with day, date, month and moon phase.',
    id: 'caliber.caliber19.description',
  },
  caliber19Power: {
    defaultMessage: 'Approx. 42-hour power reserve',
    id: 'caliber.caliber19.power',
  },
  caliber19Diamonds: {
    defaultMessage: '28,800 VPH, 38 jewels',
    id: 'caliber.caliber19.diamonds',
  },
  caliber19Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliber19.cosc',
  },

  caliber23Title: {
    defaultMessage: 'CALIBER 23',
    id: 'caliber.caliber23.title',
  },
  caliber23Description: {
    defaultMessage:
      'Automatic chronograph supplied by either ETA or Sellita. The movement enables you to measure elapsed times on a 3-6-9 or 6-9 counter display.',
    id: 'caliber.caliber23.description',
  },
  caliber23Power: {
    defaultMessage: 'Approx. 48-hour power reserve',
    id: 'caliber.caliber23.power',
  },
  caliber23Diamonds: {
    defaultMessage: '28,800 VPH, 27 jewels',
    id: 'caliber.caliber23.diamonds',
  },
  caliber23Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliber23.cosc',
  },

  caliber24Title: {
    defaultMessage: 'CALIBER 24',
    id: 'caliber.caliber24.title',
  },
  caliber24Description: {
    defaultMessage:
      'Automatic chronograph, supplied by either ETA or Sellita, enabling you to measure elapsed times and track a second time zone.',
    id: 'caliber.caliber24.description',
  },
  caliber24Power: {
    defaultMessage: 'Approx. 42-hour power reserve',
    id: 'caliber.caliber24.power',
  },
  caliber24Diamonds: {
    defaultMessage: '28,800 VPH, 25 jewels',
    id: 'caliber.caliber24.diamonds',
  },
  caliber24Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliber24.cosc',
  },

  caliber25Title: {
    defaultMessage: 'CALIBER 25',
    id: 'caliber.caliber25.title',
  },
  caliber25Description: {
    defaultMessage:
      'Automatic chronograph, supplied by Dubois-Depraz, enabling you to measure elapsed times up to one-eighth of a second thanks to a clever 30-second central chronograph hand.',
    id: 'caliber.caliber25.description',
  },
  caliber25Power: {
    defaultMessage: 'Approx. 42-hour power reserve',
    id: 'caliber.caliber25.power',
  },
  caliber25Diamonds: {
    defaultMessage: '28,800 VPH, 38 jewels',
    id: 'caliber.caliber25.diamonds',
  },
  caliber25Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliber25.cosc',
  },

  caliber32Title: {
    defaultMessage: 'CALIBER 32',
    id: 'caliber.caliber32.title',
  },
  caliber32Description: {
    defaultMessage:
      'Automatic time-only movement with a second time zone display, supplied by either ETA or Sellita.',
    id: 'caliber.caliber32.description',
  },
  caliber32Power: {
    defaultMessage: 'Approx. 42-hour power reserve',
    id: 'caliber.caliber32.power',
  },
  caliber32Diamonds: {
    defaultMessage: '28,800 VPH, 21 jewels',
    id: 'caliber.caliber32.diamonds',
  },
  caliber32Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliber32.cosc',
  },

  caliber41Title: {
    defaultMessage: 'CALIBER 41',
    id: 'caliber.caliber41.title',
  },
  caliber41Description: {
    defaultMessage:
      'Automatic chronograph, supplied by Dubois-Depraz, enabling you to measure elapsed times with a 3-9 counter display.',
    id: 'caliber.caliber41.description',
  },
  caliber41Power: {
    defaultMessage: 'Approx. 42-hour power reserve',
    id: 'caliber.caliber41.power',
  },
  caliber41Diamonds: {
    defaultMessage: '28,800 VPH, 38 jewels',
    id: 'caliber.caliber41.diamonds',
  },
  caliber41Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliber41.cosc',
  },

  caliber77Title: {
    defaultMessage: 'CALIBER 77',
    id: 'caliber.caliber77.title',
  },
  caliber77Description: {
    defaultMessage:
      'Thermo-compensated SuperQuartz™ time-only movement, supplied by ETA.',
    id: 'caliber.caliber77.description',
  },
  caliber77Power: {
    defaultMessage: 'Approx. 3 to 4 years battery life',
    id: 'caliber.caliber77.power',
  },
  caliber77Diamonds: {
    defaultMessage: '',
    id: 'caliber.caliber77.diamonds',
  },
  caliber77Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliber77.cosc',
  },

  caliber82Title: {
    defaultMessage: 'CALIBER 82',
    id: 'caliber.caliber82.title',
  },
  caliber82Description: {
    defaultMessage:
      'Thermo-compensated SuperQuartz™ chronograph movement, supplied by ETA.',
    id: 'caliber.caliber82.description',
  },
  caliber82Power: {
    defaultMessage: 'Approx. 3 to 4 years battery life',
    id: 'caliber.caliber82.power',
  },
  caliber82Diamonds: {
    defaultMessage: '',
    id: 'caliber.caliber82.diamonds',
  },
  caliber82Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliber82.cosc',
  },
  caliberB31Title: {
    defaultMessage: 'CALIBER B31',
    id: 'caliber.caliberB31.title',
  },
  caliberB31Description: {
    defaultMessage:
      'Automatic time-only movement engineered by Breitling. The B31 also features a unique free-sprung balance wheel design, providing best-in-class accuracy and an extended power-reserve.',
    id: 'caliber.caliberB31.description',
  },
  caliberB31Power: {
    defaultMessage: 'Approx. 78-hour power reserve',
    id: 'caliber.caliberB31.power',
  },
  caliberB31Diamonds: {
    defaultMessage: '"28,800 VPH, 26 jewels',
    id: 'caliber.caliberB31.diamonds',
  },
  caliberB31Cosc: {
    defaultMessage: 'COSC-certified',
    id: 'caliber.caliberB31.cosc',
  },
});
